<template>
    <aside>
        <div
            class="transform top-20 left-0 bg-white fixed h-screen overflow-scroll ease-in-out transition-all duration-500 z-40 py-2 pb-60 xl:hidden"
            :class="isOpen ? 'translate-x-0' : 'translate-x-full'"
        >
            <div class="text-[18px] leading-3 mt-2 text-black-800 w-screen">
                <div class="px-8">
                    <div class="py-4">
                        <router-link
                            data-accuid="Head_Home"
                            :to="`/${$route.params.type}`"
                        >
                            回商品頁
                        </router-link>
                    </div>
                    <div class="py-4">
                        <a
                            data-accuid="Nav_Lookup"
                            :href="memberUrl"
                        >
                            投保後查詢
                        </a>
                    </div>
                    <div class="py-4">
                        <router-link
                            data-accuid="Nav_Renewal"
                            :to="`/${$route.params.type}/renewal`"
                        >
                            續保登入
                        </router-link>
                    </div>
                    <div class="py-4">
                        <router-link
                            :to="`/${$route.params.type}/plan`"
                        >
                            試算單登入
                        </router-link>
                    </div>
                    <div class="py-4">
                        <div
                            data-accuid="Nav_Doc"
                            class="flex justify-between"
                            @click="accordionToggle('upload')"
                        >
                            <div>文件下載</div>
                            <button>
                                <component
                                    :is="accordion === 'upload' ? 'IconChevronUp' : 'IconChevronDown'"
                                    class="w-4 h-4"
                                />
                            </button>
                        </div>
    
                        <div
                            class="text-[16px] transition-all pl-6 box-border h-0 overflow-hidden"
                            :class="submenuClass('upload')"
                        >
                            <div class="py-4">
                                <a
                                    data-accuid="Nav_Epolicy"
                                    href="https://www.tmnewa.com.tw/B2C_V2/commonweb/epolicy.aspx"
                                    target="_blank"
                                >電子保單</a>
                            </div>
                            <div class="py-4">
                                <a
                                    data-accuid="Nav_Certificatequery"
                                    href="https://www.tmnewa.com.tw/b2c_v2/frontstage/certificatequery.aspx"
                                    target="_blank"
                                >電子式強制證</a>
                            </div>
                            <div class="py-4">
                                <a
                                    data-accuid="Nav_Download"
                                    href="https://www.tmnewa.com.tw/b2c_v2/frontstage/download.aspx"
                                    target="_blank"
                                >批改申請書</a>
                            </div>
                        </div>
                    </div>
                    <div class="py-4">
                        <a
                            data-accuid="Nav_ProductIntro"
                            :href="`https://www.tmnewa.com.tw/product/intro/${$route.params.type == 'car' ? '1' : '8'}`"
                            target="_blank"
                        >商品說明</a>
                    </div>
                    <div class="py-4">
                        <router-link
                            data-accuid="Nav_Faq"
                            :to="`/${$route.params.type}/faq`"
                        >
                            常見問題
                        </router-link>
                    </div>
                    <div class="py-4">
                        <a
                            data-accuid="Nav_Member"
                            :href="memberUrl"
                            target="_blank"
                        >會員專區</a>
                    </div>
                    <!-- <div class="py-4">
                        <a
                            data-accuid="Nav_Client"
                            href="https://ecchat.tmnewa.com.tw/client/client.html"
                            target="_blank"
                        >線上客服</a>
                    </div> -->
                    <div class="text-[16px] py-4">
                        <a
                            data-accuid="Nav_TMH"
                            href="https://www.tokiomarinehd.com/en/"
                            target="_blank"
                            class="flex gap-2"
                        >
                            Tokio Marine Holdings
                            <img
                                src="@/assets/images/global.png"
                                alt="Tokio Marine Holdings"
                                loading="lazy"
                                class="h-5 place-self-center"
                            >
                        </a>
                    </div>
                    <div class="py-4">
                        <div
                            v-if="$store.getters['auth/loggedIn']"
                            data-accuid="Nav_Logout"
                            class="cursor-pointer"
                            @click="logout"
                        >
                            [登出]
                        </div>
                        <router-link
                            v-else
                            data-accuid="Nav_Login"
                            :to="{ name: 'Login'}"
                            @click="$store.commit('nav/setAll', { to: $route, from: $route, clear: true})"
                        >
                            [登入註冊]
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </aside>
</template>

<script>
import IconChevronUp from '@/components/icons/ChevronUp';
import IconChevronDown from '@/components/icons/ChevronDown';

export default {
    name: 'NavigationDrawer',
    components: {IconChevronUp, IconChevronDown},
    props: {
        isOpen: {
            type: Boolean,
            default: false
        }  
    },
    data() {
        return {
            accordion: null,
            memberUrl: process.env.VUE_APP_MEMBER
        };  
    },
    computed: {
        appUrl() {
            return process.env.VUE_APP_URL;
        }
    },
    watch: {
        isOpen: {
            immediate: true,
            handler(isOpen) {
                if (isOpen) document.body.style.setProperty('overflow', 'hidden');
                else document.body.style.removeProperty('overflow');
            }
        }
    },
    methods: {
        accordionToggle(name) {
            this.accordion === name ? this.accordion = null : this.accordion = name;
        },
        logout() {

            this.$store.commit('showLoading');
            this.$store.commit('navigationDrawerClose');
            this.$auth.logout();
            this.$idle.stop();

            setTimeout(() => {
                this.$store.commit('closeLoading');
                this.$store.commit('setDialog', {
                    title: '登出成功',
                    type: 'logout',
                    text: '您已登出成功',
                    active: true
                });
            }, 500);

        },
        submenuClass(name) {
            return this.accordion === name ?'h-auto pt-4':'';
        },
    }
};
</script>